import { render, staticRenderFns } from "./FormMessage.global.vue?vue&type=template&id=1bfc5924&scoped=true&lang=pug&"
import script from "./FormMessage.global.vue?vue&type=script&lang=ts&"
export * from "./FormMessage.global.vue?vue&type=script&lang=ts&"
import style0 from "./FormMessage.global.vue?vue&type=style&index=0&id=1bfc5924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc5924",
  null
  
)

export default component.exports